import { useMemo } from "react";

import { createOryApi } from "~/libs/ory";

export const useOry = () => {
  const ory = useMemo(() => createOryApi(), []);

  return ory;
};
